import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

export default function ServiceDetail() {
  const { t } = useTranslation();
  const { id } = useParams();

  const servicesData: Record<string, any> = {
    '1': {
      title: 'استشارات إدارية',
      description: 'نقدم استشارات إدارية متخصصة تساعد مؤسستك على تحقيق التميز والنمو المستدام',
      icon: 'ri-briefcase-line',
      image: 'https://public.readdy.ai/ai/img_res/e4a4947b5f3c5fd07033d5cee2fdb1f0.jpg',
      fullDescription: 'خدمة الاستشارات الإدارية تقدم حلولاً شاملة لتطوير الأداء المؤسسي وتحسين الكفاءة التشغيلية. نعمل معك على تحليل الوضع الحالي وتحديد فرص التحسين ووضع خطط عمل قابلة للتنفيذ.',
      benefits: [
        'تحسين الأداء المؤسسي بنسبة تصل إلى 40%',
        'تقليل التكاليف التشغيلية',
        'زيادة رضا العملاء والموظفين',
        'تطوير استراتيجيات نمو مستدامة'
      ],
      process: [
        { step: 'التحليل الأولي', description: 'دراسة شاملة للوضع الحالي وتحديد التحديات' },
        { step: 'وضع الخطة', description: 'تصميم استراتيجية مخصصة تناسب احتياجاتك' },
        { step: 'التنفيذ', description: 'مساعدتك في تطبيق الحلول المقترحة' },
        { step: 'المتابعة', description: 'قياس النتائج وتحسين الأداء المستمر' }
      ]
    },
    '2': {
      title: 'التخطيط الاستراتيجي',
      description: 'نساعدك في وضع خطط استراتيجية فعالة لتحقيق أهدافك المؤسسية',
      icon: 'ri-line-chart-line',
      image: 'https://readdy.ai/api/search-image?query=strategic%20planning%20session%20with%20charts%20and%20graphs%20on%20modern%20digital%20screens%2C%20clean%20white%20background%2C%20professional%20business%20environment%2C%20corporate%20setting%2C%20high%20quality%20photography&width=1200&height=600&seq=servicedetail2&orientation=landscape',
      fullDescription: 'التخطيط الاستراتيجي هو أساس النجاح المؤسسي. نعمل معك على تحديد الرؤية والرسالة والأهداف الاستراتيجية، ووضع خطط تنفيذية واضحة لتحقيقها.',
      benefits: [
        'رؤية واضحة للمستقبل',
        'أهداف قابلة للقياس والتحقيق',
        'توافق جميع الأقسام مع الاستراتيجية',
        'قدرة أفضل على مواجهة التحديات'
      ],
      process: [
        { step: 'تحليل البيئة', description: 'دراسة السوق والمنافسين والفرص المتاحة' },
        { step: 'تحديد الأهداف', description: 'وضع أهداف استراتيجية واضحة وقابلة للقياس' },
        { step: 'بناء الخطة', description: 'تصميم خطة تنفيذية شاملة' },
        { step: 'التنفيذ والمراقبة', description: 'متابعة التنفيذ وقياس الأداء' }
      ]
    },
    '3': {
      title: 'تطوير الموارد البشرية',
      description: 'برامج تدريبية وتطويرية لتنمية مهارات فريق العمل',
      icon: 'ri-team-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20training%20session%20with%20diverse%20team%20members%20in%20modern%20training%20room%2C%20clean%20bright%20background%2C%20corporate%20learning%20environment%2C%20high%20quality%20professional%20photography&width=1200&height=600&seq=servicedetail3&orientation=landscape',
      fullDescription: 'نؤمن بأن الموارد البشرية هي أهم أصول المؤسسة. نقدم برامج تدريبية وتطويرية متخصصة لتنمية مهارات فريقك وتحسين أدائهم.',
      benefits: [
        'زيادة إنتاجية الموظفين',
        'تحسين بيئة العمل',
        'تقليل معدل دوران الموظفين',
        'بناء ثقافة مؤسسية قوية'
      ],
      process: [
        { step: 'تقييم الاحتياجات', description: 'تحديد الفجوات في المهارات والكفاءات' },
        { step: 'تصميم البرامج', description: 'إعداد برامج تدريبية مخصصة' },
        { step: 'التنفيذ', description: 'تقديم التدريب بأساليب حديثة وفعالة' },
        { step: 'التقييم', description: 'قياس أثر التدريب على الأداء' }
      ]
    },
    '4': {
      title: 'الحلول التقنية',
      description: 'حلول تقنية متكاملة لتحسين كفاءة العمل وتطوير الأنظمة',
      icon: 'ri-computer-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20technology%20solutions%20with%20digital%20interfaces%20and%20innovative%20systems%2C%20clean%20minimalist%20background%2C%20professional%20tech%20environment%2C%20high%20quality%20photography%2C%20futuristic%20atmosphere&width=1200&height=600&seq=servicedetail4&orientation=landscape',
      fullDescription: 'نقدم حلولاً تقنية متطورة تساعد مؤسستك على التحول الرقمي وتحسين الكفاءة التشغيلية من خلال أنظمة وتطبيقات مخصصة.',
      benefits: [
        'أتمتة العمليات وتوفير الوقت',
        'تحسين دقة البيانات',
        'سهولة الوصول للمعلومات',
        'تقارير وتحليلات متقدمة'
      ],
      process: [
        { step: 'تحليل المتطلبات', description: 'فهم احتياجاتك التقنية بدقة' },
        { step: 'التصميم', description: 'تصميم حلول تقنية مناسبة' },
        { step: 'التطوير', description: 'بناء الأنظمة والتطبيقات' },
        { step: 'الدعم', description: 'دعم فني مستمر وتحديثات دورية' }
      ]
    },
    '5': {
      title: 'التسويق الرقمي',
      description: 'استراتيجيات تسويقية رقمية لزيادة الوصول وتحقيق النمو',
      icon: 'ri-megaphone-line',
      image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20workspace%20with%20social%20media%20analytics%20and%20creative%20content%20on%20screens%2C%20clean%20modern%20background%2C%20professional%20marketing%20environment%2C%20high%20quality%20photography&width=1200&height=600&seq=servicedetail5&orientation=landscape',
      fullDescription: 'نساعدك في بناء حضور رقمي قوي وتحقيق أهدافك التسويقية من خلال استراتيجيات تسويق رقمي متكاملة ومبتكرة.',
      benefits: [
        'زيادة الوعي بالعلامة التجارية',
        'وصول أوسع للجمهور المستهدف',
        'تحسين معدلات التحويل',
        'عائد استثمار أفضل'
      ],
      process: [
        { step: 'البحث والتحليل', description: 'دراسة السوق والجمهور المستهدف' },
        { step: 'الاستراتيجية', description: 'وضع خطة تسويقية شاملة' },
        { step: 'التنفيذ', description: 'إطلاق الحملات التسويقية' },
        { step: 'التحسين', description: 'تحليل النتائج وتحسين الأداء' }
      ]
    },
    '6': {
      title: 'الاستشارات المالية',
      description: 'استشارات مالية متخصصة لإدارة الموارد وتحقيق الاستدامة المالية',
      icon: 'ri-money-dollar-circle-line',
      image: 'https://readdy.ai/api/search-image?query=financial%20consulting%20with%20professional%20charts%20and%20financial%20reports%2C%20clean%20bright%20background%2C%20corporate%20finance%20environment%2C%20high%20quality%20professional%20photography&width=1200&height=600&seq=servicedetail6&orientation=landscape',
      fullDescription: 'نقدم استشارات مالية متخصصة تساعدك على إدارة مواردك المالية بكفاءة وتحقيق الاستدامة المالية لمؤسستك.',
      benefits: [
        'تحسين التدفقات النقدية',
        'تقليل المخاطر المالية',
        'زيادة الربحية',
        'قرارات مالية مدروسة'
      ],
      process: [
        { step: 'التحليل المالي', description: 'دراسة الوضع المالي الحالي' },
        { step: 'التخطيط', description: 'وضع خطط مالية استراتيجية' },
        { step: 'التنفيذ', description: 'تطبيق الحلول المالية' },
        { step: 'المراقبة', description: 'متابعة الأداء المالي' }
      ]
    }
  };

  const service = servicesData[id || '1'];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0 w-full h-full">
          <img 
            src={service.image} 
            alt={service.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="w-20 h-20 flex items-center justify-center bg-white rounded-full mx-auto mb-6 shadow-xl">
              <i className={`${service.icon} text-4xl text-blue-600`}></i>
            </div>
            <h1 className="text-5xl font-bold mb-6">{service.title}</h1>
            <p className="text-xl text-gray-100 leading-relaxed">
              {service.description}
            </p>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">نظرة عامة</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-12">
              {service.fullDescription}
            </p>

            {/* Benefits */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 mb-12">
              <h3 className="text-2xl font-bold text-gray-800 mb-6">الفوائد الرئيسية</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {service.benefits.map((benefit: string, index: number) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-green-500 rounded-full flex-shrink-0 mt-1">
                      <i className="ri-check-line text-white text-lg"></i>
                    </div>
                    <span className="text-gray-700 leading-relaxed">{benefit}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Process */}
            <h3 className="text-2xl font-bold text-gray-800 mb-8">خطوات العمل</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              {service.process.map((item: any, index: number) => (
                <div key={index} className="bg-white border-2 border-gray-200 rounded-xl p-6 hover:border-blue-500 transition-colors">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-blue-600 text-white rounded-full text-xl font-bold">
                      {index + 1}
                    </div>
                    <h4 className="text-xl font-bold text-gray-800">{item.step}</h4>
                  </div>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-10 text-center text-white">
              <h3 className="text-3xl font-bold mb-4">هل أنت مستعد للبدء؟</h3>
              <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                تواصل معنا الآن واحصل على استشارة مجانية حول هذه الخدمة
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <Link 
                  to="/request-service"
                  className="inline-flex items-center gap-3 bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span>اطلب الخدمة الآن</span>
                  <i className="ri-arrow-left-line"></i>
                </Link>
                <Link 
                  to="/contact"
                  className="inline-flex items-center gap-3 bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <span>تواصل معنا</span>
                  <i className="ri-phone-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}